import { Routes } from '@angular/router';
import { LayoutPage } from './layout/layout.page';
import { AuthGuard } from './shared/guards/auth.guard';
import { NoAuthGuard } from './shared/guards/no-auth.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () =>
      import('./pages/login/login.component').then((m) => m.LoginComponent),
    canActivate: [NoAuthGuard],
  },
  {
    path: 'test/solar-rent',
    loadComponent: () =>
      import('./pages/wizards/solar-rent-wizard/solar-rent-wizard.component').then(
        (m) => m.SolarRentWizardComponent
      ),
    data: { testMode: true },
  },
  {
    path: 'test/solar-rent/:contractId/:step/:subStep',
    loadComponent: () =>
      import('./pages/wizards/solar-rent-wizard/solar-rent-wizard.component').then(
        (m) => m.SolarRentWizardComponent
      ),
    data: { testMode: true },
  },
  {
    path: 'test/solar-rent/:contractId/:step',
    loadComponent: () =>
      import('./pages/wizards/solar-rent-wizard/solar-rent-wizard.component').then(
        (m) => m.SolarRentWizardComponent
      ),
    data: { testMode: true },
  },
  {
    path: 'test/solar-rent/:contractId',
    loadComponent: () =>
      import('./pages/wizards/solar-rent-wizard/solar-rent-wizard.component').then(
        (m) => m.SolarRentWizardComponent
      ),
    data: { testMode: true },
  },
  {
    path: '',
    component: LayoutPage,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
      },
      {
        path: 'home',
        loadComponent: () =>
          import('./pages/home/home.page').then((m) => m.HomePage),
      },
      {
        path: 'menu',
        loadComponent: () =>
          import('./components/menu/menu.component').then((m) => m.MenuComponent),
      },
      {
        path: 'simulation/:id',
        loadComponent: () =>
          import('./pages/simulation/simulation-wizard.component').then(
            (m) => m.SimulationWizardComponent
          ),
      },
      {
        path: 'solar-rent/:contractId/:step/:subStep',
        loadComponent: () =>
          import('./pages/wizards/solar-rent-wizard/solar-rent-wizard.component').then(
            (m) => m.SolarRentWizardComponent
          ),
      },
      {
        path: 'solar-rent/:contractId/:step',
        loadComponent: () =>
          import('./pages/wizards/solar-rent-wizard/solar-rent-wizard.component').then(
            (m) => m.SolarRentWizardComponent
          ),
      },
      {
        path: 'solar-rent/:contractId',
        loadComponent: () =>
          import('./pages/wizards/solar-rent-wizard/solar-rent-wizard.component').then(
            (m) => m.SolarRentWizardComponent
          ),
      },
      {
        path: 'forbidden',
        loadComponent: () =>
          import('./pages/forbidden/forbidden.page').then((m) => m.ForbiddenPage),
      },
      {
        path: 'not-found',
        loadComponent: () =>
          import('./pages/not-found/not-found.page').then((m) => m.NotFoundPage),
      },
      {
        path: '**',
        loadComponent: () =>
          import('./pages/not-found/not-found.page').then((m) => m.NotFoundPage),
      },
    ],
  },
];
